/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalIntegration
 */
export interface PalIntegration {
    /**
     * 
     */
    name: PalIntegrationNameEnum;
    /**
     * 
     */
    status: PalIntegrationStatusEnum;
}


/**
 * @export
 */
export const PalIntegrationNameEnum = {
    Availity: 'Availity',
    NaviHealth: 'naviHealth',
    UnitedHealthcare: 'UnitedHealthcare',
} as const;
export type PalIntegrationNameEnum = typeof PalIntegrationNameEnum[keyof typeof PalIntegrationNameEnum];

/**
 * @export
 */
export const PalIntegrationStatusEnum = {
    Complete: 'complete',
    Disabled: 'disabled',
} as const;
export type PalIntegrationStatusEnum = typeof PalIntegrationStatusEnum[keyof typeof PalIntegrationStatusEnum];


/**
 * Check if a given object implements the PalIntegration interface.
 */
export function instanceOfPalIntegration(value: object): value is PalIntegration {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PalIntegrationFromJSON(json: any): PalIntegration {
    return PalIntegrationFromJSONTyped(json, false);
}

export function PalIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalIntegration {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'status': json['status'],
    };
}

export function PalIntegrationToJSON(json: any): PalIntegration {
    return PalIntegrationToJSONTyped(json, false);
}

export function PalIntegrationToJSONTyped(value?: PalIntegration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': value['status'],
    };
}

